import { Button, Paper, Stack } from "@mui/material";
import { FormExample } from "./form";
import { DataTableExample } from "./data-table";

export const CheatSheet = () => {
  return (
    <div style={{ padding: "1rem" }} className="view-root cheat-sheet-view">
      <h1>Cheat Sheet</h1>

      <div>
        <Stack spacing={2} alignItems="flex-start">
          <Button variant="contained" color="primary">
            Test Primary
          </Button>

          <Button variant="contained" color="secondary">
            Test Secondary
          </Button>

          <Button variant="outlined" color="primary">
            Test Primary
          </Button>

          <Button variant="outlined" color="secondary">
            Test Secondary
          </Button>

          <Button variant="contained" color="info">
            Test Info
          </Button>

          <Button variant="contained" color="success">
            Test Success
          </Button>

          <Button variant="contained" color="error">
            Test Error
          </Button>

          <Button variant="contained" color="warning">
            Test Warning
          </Button>

          <Paper style={{ padding: "12px 18px 32px" }} elevation={1}>
            Paper 1
          </Paper>
          <Paper style={{ padding: "12px 18px 32px" }} elevation={2}>
            Paper 2
          </Paper>
          <Paper style={{ padding: "12px 18px 32px" }} elevation={3}>
            Paper 3
          </Paper>
        </Stack>
      </div>

      <FormExample />

      <DataTableExample />
    </div>
  );
};
